export default __webpack_public_path__ + "static/media/lieferheld_xl3.e57456ea.png";